// constants.js
export const O_CLIENT_TYPE = "OLIVEEB_ADMIN_PORTAL_WEB_UI";
const HOST ='dev.oliveeb.com';
export const AUTHORIZATION_HEADER_KEY = "Authorization";
export const ACTOR_ID_HEADER_KEY = "O-ACTOR-ID";
export const CLIENT_ID = 'bac18874-9c8b-4ee5-8b3d-63734e6c24d8';
export const CLIENT_NAME_HEADER_KEY = "O-CLIENT-NAME";
export const CLIENT_NAME_HEADER_VALUE = "OMC";
export const STORAGE_BASE_URL = "https://dev.oliveeb.com/storage-service";
